module.exports = __webpack_public_path__ + "img/10_26.22dd9e43.png";